'use strict';

angular.module('betosyswebapp')
  .controller('TrackDashboardCtrl', function ($rootScope, $scope, AuthenticationService, base64, localStorageService, $translate, commonTrackService, dashboardService, customerService) {
    $scope.pageHeader = 'BetoTrack Dashboard';

    var loginID = AuthenticationService.GetLoginID();
    //var password = base64.decode($rootScope.globals.currentUser.authdata).split(':')[1];
    /*

     $scope.mapUrl = 'track/Track?account=' + loginID.Account + '&user=' +loginID.username+'&password='+password+'&page=report.show&page_cmd=rptsel&page_cmd_arg&device=0056&r_report=EventDetail&r_option&r_text&date_fr=2015%2f07%2f01%2f00%3a00&date_to=2015%2f12%2f01%2f23%3a59&date_tz=Europe%2fBerlin&r_limit&r_limType&r_emailAddr&r_menu=menu.rpt.devDetail&fmt=map';
     */

    //$scope.mapUrl = 'fleetapi/map';


    $scope.closeAlert = function () {
      $scope.error = false;
    };

    //dash board
    $scope.username = loginID.username;
    $scope.dashBoardName = 'dashBoard.Plan.' + $scope.username;
    var model = localStorageService.get($scope.dashBoardName);
    if (model) {
      commonTrackService._loopWidgetsInDashboard(model, commonTrackService.getVehicleBasedWidgetNameArray(), null);
      commonTrackService._loopWidgetsInDashboard(model, commonTrackService.getVehicleBasedWidgetNameArray(), null);
    }
    if (!model) {
      // set default model
      model = customerService.getLastLocationDashboardConfig(commonTrackService.getViewPortName());

    }


    $scope.dashBoardModel = model;
    $scope.collapsible = true;
    $scope.maximizable = true;

    $scope.widgetFilter = function (widget, type) {
      if (!isExculdedParentWidget(type) && (widget.isSingleInstance === undefined || notExist(type))) {
        return type;
      }
    };

    function notExist(type) {
      return !dashboardService.getDashboardWidget($scope.dashBoardModel, type);
    }
    var isExculdedParentWidgetArr = ['DriverWrkHrsWidget', 'tachoHistoryWidget', 'FMSVehicleWidget', 'tachoDownloadStatusWidget'];

    function isExculdedParentWidget(type) {
      for (var j = 0; j < isExculdedParentWidgetArr.length; j++) {
        if (type === isExculdedParentWidgetArr[j]) {
          return true;
        }
      }
      return false;
    }
    var adfDashboardChangedEvnt = $scope.$on('adfDashboardChanged', function (event, name, model) {
      localStorageService.set(name, model);
    });

    var vehicleGroupChangedEvnt = $scope.$on('vehicleGroupChanged', function (event, data) {
      commonTrackService._loopWidgetsInDashboard($scope.dashBoardModel, commonTrackService.getFleetBasedWidgetNameArray(), data.selectedVehicleGroupLabel);
    });

    var widgetDataFromServer = $scope.$on('init-widget-data-from-server', function (event, data) {
      if (data.selectedRow) {
        var dateSting  = moment(data.selectedRow.date).format('DD.MM.YYYY');
        commonTrackService._loopWidgetsInDashboard($scope.dashBoardModel, [{
          name: 'tachoEventDetailWidget',
          titleTranslationKey: 'dashBoard.fleetManagement.tachoEventDetail.tachoEventDetailTitle'
        }], dateSting);
      }
    });

    var rowSelectedEvnt = $scope.$on('rowSelected', function (event, data) {
      if (data.updateWidgetTitle) {
        if (data.selectedRow) {
          commonTrackService._loopWidgetsInDashboard($scope.dashBoardModel, commonTrackService.getVehicleBasedWidgetNameArray(), data.selectedRow.devicedesc);
        } else {
          commonTrackService._loopWidgetsInDashboard($scope.dashBoardModel, commonTrackService.getVehicleBasedWidgetNameArray(), null);
        }
      }
    });

    $scope.$on('$destroy', function () {
        adfDashboardChangedEvnt();
        vehicleGroupChangedEvnt();
        rowSelectedEvnt();
        widgetDataFromServer();
      }
    );
  });



// WEBPACK FOOTER //
// ./.tmp/components/dashboard/trackDashboardController.js